import iziToast from 'izitoast'

export const notify = (params) => {
    iziToast[params.type]({
        title: params.title,
        message: params.message || '',
        position: params.position || 'topRight',
        close: params.hasOwnProperty('close')? params.close: false,
        overlay: params.hasOwnProperty('overlay')? params.overlay : false,
        timeout: params.hasOwnProperty('timeout')? params.timeout : 1900,
        animateInside: params.hasOwnProperty('animateInside')? params.animateInside : false,
        pauseOnHover:  params.hasOwnProperty('pauseOnHover')? params.pauseOnHover : false,
        resetOnHover:  params.hasOwnProperty('resetOnHover')? params.resetOnHover : false,
        progressBar:  params.hasOwnProperty('progressBar')? params.progressBar : false,
        rtl:  params.hasOwnProperty('rtl')? params.rtl : false,
        onOpening: params.hasOwnProperty('onOpening')? params.onOpening: function () {},
        onOpened: params.hasOwnProperty('onOpened')? params.onOpened: function () {},
        onClosing: params.hasOwnProperty('onClosing')? params.onClosing: function () {},
        onClosed: params.hasOwnProperty('onClosed')? params.onClosed: function () {}
    });
}

export const notifySuccess = (title) => {
    notify({
        type: 'success',
        title: title,
        position: 'topRight',
    })
}

export const notifyDanger = (title) => {
    notify({
        type: 'error',
        title: title,
        position: 'topRight',
    })
}

export default {
    notify,
    notifySuccess,
    notifyDanger
}
